import { render, staticRenderFns } from "./VimeoLive.vue?vue&type=template&id=b4ca8b52&"
import script from "./VimeoLive.vue?vue&type=script&lang=js&"
export * from "./VimeoLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../var/www/html/film-screening-production/avails/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports